const state = {
    itens: [],
    item: {
    }
};

export default state;